var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileDevices = function SvgMobileDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.541 1.748v1.05a.325.325 0 0 0 .292.35h2.334a.325.325 0 0 0 .292-.35v-1.05M5.833 10.5h2.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.334 12.252H4.666a1.167 1.167 0 0 1-1.167-1.167v-8.17c0-.644.522-1.167 1.167-1.167h4.668c.645 0 1.168.523 1.168 1.167v8.17c0 .645-.523 1.167-1.168 1.167",
    clipRule: "evenodd"
  })));
};
export { SvgMobileDevices as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzhhNmRhZmQxZGNlNjkwYjgzZDZlNjAzMDFhMWM5ZmEuc3ZnIjs=";